// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vzd-directory-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.vzd-directory-page .settings-modal-header {
  position: relative;
  justify-content: center;
}

.vzd-directory-page .back-button {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.vzd-directory-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.vzd-section {
  margin-bottom: 32px;
}

.vzd-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.vzd-toggles {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Status boxes - reuse notification pattern */
.vzd-status-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.vzd-status-box ion-icon {
  font-size: 32px;
}

.vzd-status-box.warning {
  background-color: #fff8e1;
  border: 1px solid #ffc107;
}

.vzd-status-box.warning ion-icon {
  color: #ff9800;
}

.vzd-status-box.info {
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
}

.vzd-status-box.info ion-icon {
  color: #2196f3;
}

.vzd-status-box.success {
  background-color: #e8f5e9;
  border: 1px solid #4caf50;
}

.vzd-status-box.success ion-icon {
  color: #388e3c;
}

/* Loading spinner animation */
.vzd-loading-spinner {
  animation: vzd-spin 1s linear infinite;
}

@keyframes vzd-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.vzd-retry-button {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background-color: var(--netsfere-red);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.vzd-retry-button:hover {
  background-color: #b82419;
}

.vzd-updating-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  font-size: 14px;
  color: #666;
}

.vzd-updating-indicator ion-icon {
  font-size: 18px;
}

@media (max-width: 600px) {
  .vzd-directory-content {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/VzdDirectoryPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,sCAAsC;AACxC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".vzd-directory-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.vzd-directory-page .settings-modal-header {\n  position: relative;\n  justify-content: center;\n}\n\n.vzd-directory-page .back-button {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.vzd-directory-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.vzd-section {\n  margin-bottom: 32px;\n}\n\n.vzd-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 16px;\n}\n\n.vzd-toggles {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Status boxes - reuse notification pattern */\n.vzd-status-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.vzd-status-box ion-icon {\n  font-size: 32px;\n}\n\n.vzd-status-box.warning {\n  background-color: #fff8e1;\n  border: 1px solid #ffc107;\n}\n\n.vzd-status-box.warning ion-icon {\n  color: #ff9800;\n}\n\n.vzd-status-box.info {\n  background-color: #e3f2fd;\n  border: 1px solid #2196f3;\n}\n\n.vzd-status-box.info ion-icon {\n  color: #2196f3;\n}\n\n.vzd-status-box.success {\n  background-color: #e8f5e9;\n  border: 1px solid #4caf50;\n}\n\n.vzd-status-box.success ion-icon {\n  color: #388e3c;\n}\n\n/* Loading spinner animation */\n.vzd-loading-spinner {\n  animation: vzd-spin 1s linear infinite;\n}\n\n@keyframes vzd-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.vzd-retry-button {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  background-color: var(--netsfere-red);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.vzd-retry-button:hover {\n  background-color: #b82419;\n}\n\n.vzd-updating-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 16px;\n  font-size: 14px;\n  color: #666;\n}\n\n.vzd-updating-indicator ion-icon {\n  font-size: 18px;\n}\n\n@media (max-width: 600px) {\n  .vzd-directory-content {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
